import React, { memo, MouseEvent } from 'react'
import CloseIcon from 'transfix-icons/build/CloseIcon'
import EditIcon from 'transfix-icons/build/EditIcon'
import { TEST_IDS } from './constants'

const { CLOSE_ICON, EDIT_ICON } = TEST_IDS

interface IIconProps {
  editing: boolean
  clickHandler: (event: MouseEvent<HTMLButtonElement>) => void
}

export const Icon = memo(({ clickHandler, editing }: IIconProps) => (
  <button onClick={clickHandler} className='showable btn-text-link'>
    <div className='inline-right'>
      {editing ? <CloseIcon data-test={CLOSE_ICON} /> : <EditIcon data-test={EDIT_ICON} />}
    </div>
  </button>
))
